import { Button, Text, tooltipStyle } from '@wfp/react';
import { Tooltip } from 'acr_ui/sources/components/Tooltip';
import React from 'react';
import { Helmet } from 'react-helmet';
import Select from 'react-select';

interface OptionType {
  value: string;
  label: string;
}

interface AdministrationDashboardHeaderProps {
  periods?: string[];
  period: string;
  setPeriod: (period: string) => void;
  generateProjects: () => void;
  activateProjects: () => void;
  loading: boolean;
  selectedProjects: string[];
}

function AdministrationDashboardHeaderComponent(
  props: AdministrationDashboardHeaderProps,
) {
  const periods = props.periods ?? [];
  const options: OptionType[] = periods.map((period: string) => {
    return { value: period, label: period };
  });
  const className = 'administration-dashboard-header';

  return (
    <>
      <Helmet>
        <title>Administration Dashboard</title>
      </Helmet>

      <div className={className}>
        <Text className={`${className}-title`} kind="h1">
          Administration Dashboard
        </Text>
        <div className={`${className}-controls`}>
          <Tooltip
            title="Select at least one project"
            trigger="mouseenter"
            {...tooltipStyle}
            theme="light"
            position="bottom"
            disabled={props.selectedProjects?.length > 0}
          >
            <Button
              onClick={props.generateProjects}
              disabled={props.loading || props.selectedProjects?.length === 0}
            >
              Generate selected projects
            </Button>
          </Tooltip>
          <Tooltip
            title="Select at least one project"
            trigger="mouseenter"
            {...tooltipStyle}
            theme="light"
            position="bottom"
            disabled={props.selectedProjects?.length > 0}
          >
            <Button
              onClick={props.activateProjects}
              disabled={props.loading || props.selectedProjects?.length === 0}
            >
              Activate selected projects
            </Button>
          </Tooltip>
          <div className={`${className}-period-picker`}>
            <Text className={`${className}-period-picker-title`}>Period</Text>
            <Select
              className="admin-dashboard-react-select"
              classNamePrefix="wfp--react-select"
              name="projectTypeFilters"
              options={options}
              isSearchable={false}
              value={{ value: props.period, label: props.period }}
              id="adminDashboardPeriodsSelectId"
              key="adminDashboardPeriodsSelectId"
              onChange={(selectedOption: OptionType | null) => {
                if (selectedOption) {
                  props.setPeriod(selectedOption.value);
                }
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default AdministrationDashboardHeaderComponent;
